const deleteFields = (data, operation) => {
    for (const field of operation.fields) {
        delete data[field]
    }
    return data
}

export default deleteFields